import type { KK, SetMagnetSenior, VK } from './define'

// 定义 PostInt 接口
export interface PostInt {
  Value: number
}

// 定义 PostCfgRename 接口
export interface PostCfgRename {
  ID: number
  Name: string
}

// 定义 PostCfgBindShortCut 接口
export interface PostCfgBindShortCut {
  ID: number
  Shortcut: VK[]
}

export interface PostOnboardCfgRename {
  Slot: number
  Name: string
}

// 定义 PostString 接口
export interface PostString {
  Value: string
}

export interface PostImportSetting {
  Name: string
  DataBase64: string
}

export interface PostImportReplace {
  Name: string
  DataBase64: string
  ReplaceIndex: number
}

export enum WatchType {
  Start = 1,
  Stop = 2,
}

export interface PostWatchKey {
  WatchType: WatchType //1开始 2结束
}

export enum SetKeyType {
  KeyMapKeyboard = 0x01,
  KeyMedia = 0x02,
  KeyMapMouse = 0x03,
  KeyMacro = 0x04,
  KeyModifer = 0x05,
  KeyMagnetFunction = 0x06,
  KeyFire = 7,
}

export interface PostSetKey {
  Key: { [index: KK]: VK }
  KeyModifier: { [index: KK]: VK[] }
  KeyFire: { [index: KK]: number[] }
  KeyType: SetKeyType
  IsFn: boolean
}

export interface PostMagnetSetSeniorKey {
  IsFn: boolean
  Key: KK
  Value: SetMagnetSenior
}
